export class AuditClaimTag {
  ClientId: number;
  RawDataImport_ShardClaimIdentifier: number;
  TagId: number;
  UserID: number;
  TagDesc: string;
  TagCode: string;
  CreateDate: Date;
  Source: string;
}